import MetaRow from "../../components/MetaRow/MetaRow";
import Chart from "../../components/Chart/Chart";
import Watchlist from "../../components/Watchlist/Watchlist";
import Performances from "../../components/Performances/Performances";
import StrategiesWiseAnalysis from "../../components/StrategiesWiseAnalysis/StrategiesWiseAnalysis";
import styles from "./DashboardPage.module.css";

function DashboardPage() {
  // Holding Analysis data by Family dropdown
  const holdingDataByFamily = {
    family1: [
      { name: "Technology", value: 31.02, color: "#3B82F6" },
      { name: "Financial Services", value: 12.36, color: "#8B5CF6" },
      { name: "Healthcare", value: 12.00, color: "#A78BFA" },
      { name: "Consumer Cyclical", value: 10.51, color: "#EF4444" },
      { name: "Communication Services", value: 9.85, color: "#F97316" },
      { name: "Industrial", value: 8.42, color: "#8B4513" },
      { name: "Consumer Defensive", value: 8.15, color: "#F59E0B" },
      { name: "Energy", value: 7.69, color: "#10B981" },
    ],
    family2: [
      { name: "Technology", value: 28.50, color: "#3B82F6" },
      { name: "Financial Services", value: 14.20, color: "#8B5CF6" },
      { name: "Healthcare", value: 13.15, color: "#A78BFA" },
      { name: "Consumer Cyclical", value: 11.25, color: "#EF4444" },
      { name: "Communication Services", value: 10.10, color: "#F97316" },
      { name: "Industrial", value: 9.30, color: "#8B4513" },
      { name: "Consumer Defensive", value: 7.80, color: "#F59E0B" },
      { name: "Energy", value: 5.70, color: "#10B981" },
    ],
    family3: [
      { name: "Technology", value: 33.15, color: "#3B82F6" },
      { name: "Financial Services", value: 15.40, color: "#8B5CF6" },
      { name: "Healthcare", value: 14.25, color: "#A78BFA" },
      { name: "Consumer Cyclical", value: 12.10, color: "#EF4444" },
      { name: "Communication Services", value: 10.50, color: "#F97316" },
      { name: "Industrial", value: 7.20, color: "#8B4513" },
      { name: "Consumer Defensive", value: 4.80, color: "#F59E0B" },
      { name: "Energy", value: 2.60, color: "#10B981" },
    ],
  };

  // Family dropdown options
  const familyOptions = [
    { value: "family1", label: "Family 1" },
    { value: "family2", label: "Family 2" },
    { value: "family3", label: "Family 3" },
  ];

  // Strategies Wise Analysis data organized by time filter
  const strategiesData = {
    lastYear: [
      { name: "Straddle", value: 33, overallPnL: "12.00%", drawdown: "12.05%", winningStreak: "12.05%", losingStreak: "12.05%" },
      { name: "Strangle", value: 44, overallPnL: "12.00%", drawdown: "12.05%", winningStreak: "12.05%", losingStreak: "12.05%" },
      { name: "Directional", value: 24, overallPnL: "12.00%", drawdown: "12.05%", winningStreak: "12.05%", losingStreak: "12.05%" },
      { name: "Seagull", value: 53, overallPnL: "12.00%", drawdown: "12.05%", winningStreak: "12.05%", losingStreak: "12.05%" },
      { name: "Batman", value: 61, overallPnL: "12.00%", drawdown: "12.05%", winningStreak: "12.05%", losingStreak: "12.05%" },
      { name: "Dummy1", value: 17, overallPnL: "12.00%", drawdown: "12.05%", winningStreak: "12.05%", losingStreak: "12.05%" },
      { name: "Dummy2", value: 11, overallPnL: "12.00%", drawdown: "12.05%", winningStreak: "12.05%", losingStreak: "12.05%" },
      { name: "Batman", value: 77, overallPnL: "12.00%", drawdown: "12.05%", winningStreak: "12.05%", losingStreak: "12.05%" },
      { name: "Dummy3", value: 47, overallPnL: "12.00%", drawdown: "12.05%", winningStreak: "12.05%", losingStreak: "12.05%" },
      { name: "Dummy4", value: 65, overallPnL: "12.00%", drawdown: "12.05%", winningStreak: "12.05%", losingStreak: "12.05%" },
      { name: "Dummy5", value: 18, overallPnL: "12.00%", drawdown: "12.05%", winningStreak: "12.05%", losingStreak: "12.05%" },
      { name: "Dummy6", value: 34, overallPnL: "12.00%", drawdown: "12.05%", winningStreak: "12.05%", losingStreak: "12.05%" },
    ],
    thisYear: [
      { name: "Straddle", value: 35, overallPnL: "12.00%", drawdown: "12.05%", winningStreak: "12.05%", losingStreak: "12.05%" },
      { name: "Strangle", value: 42, overallPnL: "12.00%", drawdown: "12.05%", winningStreak: "12.05%", losingStreak: "12.05%" },
      { name: "Directional", value: 26, overallPnL: "12.00%", drawdown: "12.05%", winningStreak: "12.05%", losingStreak: "12.05%" },
      { name: "Seagull", value: 55, overallPnL: "12.00%", drawdown: "12.05%", winningStreak: "12.05%", losingStreak: "12.05%" },
      { name: "Batman", value: 63, overallPnL: "12.00%", drawdown: "12.05%", winningStreak: "12.05%", losingStreak: "12.05%" },
      { name: "Dummy1", value: 19, overallPnL: "12.00%", drawdown: "12.05%", winningStreak: "12.05%", losingStreak: "12.05%" },
      { name: "Dummy2", value: 13, overallPnL: "12.00%", drawdown: "12.05%", winningStreak: "12.05%", losingStreak: "12.05%" },
      { name: "Batman", value: 79, overallPnL: "12.00%", drawdown: "12.05%", winningStreak: "12.05%", losingStreak: "12.05%" },
      { name: "Dummy3", value: 49, overallPnL: "12.00%", drawdown: "12.05%", winningStreak: "12.05%", losingStreak: "12.05%" },
      { name: "Dummy4", value: 67, overallPnL: "12.00%", drawdown: "12.05%", winningStreak: "12.05%", losingStreak: "12.05%" },
      { name: "Dummy5", value: 20, overallPnL: "12.00%", drawdown: "12.05%", winningStreak: "12.05%", losingStreak: "12.05%" },
      { name: "Dummy6", value: 36, overallPnL: "12.00%", drawdown: "12.05%", winningStreak: "12.05%", losingStreak: "12.05%" },
    ],
  };

  // Strategies time filter options
  const strategiesTimeFilterOptions = [
    { value: "lastYear", label: "Last year" },
    { value: "thisYear", label: "This year" },
  ];

  // Performances data organized by tabs
  const performancesData = {
    ALL: [
      {
        securityCode: 544391,
        securityName: "ZUARIIND",
        ltp: "36.43",
        change: "6.07",
        percentageChange: "19.99",
        changeIsPositive: false,
      },
      {
        securityCode: 544428,
        securityName: "CSURGSU",
        ltp: "51.22",
        change: "8.53",
        percentageChange: "19.98",
        changeIsPositive: true,
      },
      {
        securityCode: 540143,
        securityName: "APEX",
        ltp: "120.20",
        change: "20.00",
        percentageChange: "19.96",
        changeIsPositive: false,
      },
      {
        securityCode: 526953,
        securityName: "THREEMPAPE",
        ltp: "321.00",
        change: "45.65",
        percentageChange: "16.58",
        changeIsPositive: true,
      },
      {
        securityCode: 526953,
        securityName: "CORNE",
        ltp: "109.00",
        change: "14.10",
        percentageChange: "14.86",
        changeIsPositive: true,
      },
      {
        securityCode: 526953,
        securityName: "ATULAUTO",
        ltp: "38.85",
        change: "4.35",
        percentageChange: "12.61",
        changeIsPositive: false,
      },
      {
        securityCode: 526953,
        securityName: "BENCHMARK",
        ltp: "527.60",
        change: "58.50",
        percentageChange: "12.47",
        changeIsPositive: true,
      },
    ],
    "Top Gainers": [
      {
        securityCode: 544428,
        securityName: "CSURGSU",
        ltp: "51.22",
        change: "8.53",
        percentageChange: "19.98",
        changeIsPositive: true,
      },
      {
        securityCode: 526953,
        securityName: "THREEMPAPE",
        ltp: "321.00",
        change: "45.65",
        percentageChange: "16.58",
        changeIsPositive: true,
      },
    ],
    "Top Losers": [
      {
        securityCode: 544391,
        securityName: "ZUARIIND",
        ltp: "36.43",
        change: "6.07",
        percentageChange: "19.99",
        changeIsPositive: false,
      },
      {
        securityCode: 540143,
        securityName: "APEX",
        ltp: "120.20",
        change: "20.00",
        percentageChange: "19.96",
        changeIsPositive: false,
      },
    ],
    Volume: [],
    "Heat map": [],
  };

  // Example data array - replace with actual data
  const metaDataArray = [
    {
      iconName: "UpDownArrowIcon",
      primaryLabel: "Total",
      secondaryLabel: "PnL",
      value: 721882,
      percentageChange: -4.66,
      isPositive: false,
      color: "#FFC246",
      graphData: [20, 35, 25, 45, 30, 50, 40, 15, 30, 45],
    },
    {
      iconName: "UpDownArrowIcon",
      primaryLabel: "Realised",
      secondaryLabel: "PnL",
      value: 22370,
      percentageChange: 0.45,
      isPositive: true,
      color: "#3B82F6",
      graphData: [15, 20, 18, 25, 22, 28, 24, 20, 23, 25],
    },
    {
      iconName: "UpDownArrowIcon",
      primaryLabel: "Unrealised",
      secondaryLabel: "PnL",
      value: 10604,
      percentageChange: -1.07,
      isPositive: false,
      color: "#10B981",
      graphData: [30, 28, 32, 25, 30, 22, 28, 25, 27, 24],
    },
  ];

  return (
    <div className={styles["dashboard-page"]}>
      {/* Left Side - All Main Content */}
      <div className={styles["dashboard-left"]}>
        {/* Top Section - MetaRow Cards */}
        <div className={styles["dashboard-grid-top"]}>

          <MetaRow data={metaDataArray} />
        </div>

        {/* Middle Section */}
        <div className={styles["dashboard-grid"]}>
          {/* Holding Analysis */}
          <div
            className={`${styles["dashboard-section"]} ${styles["dashboard-grid-bottom-left"]}`}
          >
            <div className={styles["chart-section"]}>
              <Chart
                chartType="donut"
                dataByDropdown={holdingDataByFamily}
                options={{
                  height: 196,
                  width: "100%",
                  chartMaxWidth: 196,
                  chartMaxHeight: 196,
                  showDropdown: true,
                  dropdownOptions: familyOptions,
                  title: "Holding Analysis",
                  showTitle: true,
                  showHeader: true,
                  innerRadius: 70,
                  outerRadius: 120,
                  chartWidth: "100%",
                  legendWidth: "100%",
                  // chartLegendGap: "20px",
                  // pieChartMargin: { top: 20, right: 20, bottom: 20, left: 20 },
                  hoverExpandAmount: 8,
                  legendLabelSuffix: "Script",
                  pieDataKey: "value",
                  pieCx: "50%",
                  pieCy: "50%",
                  showLegend: true,
                }}
              />
            </div>
          </div>

          {/* Performances */}
          <div
            className={`${styles["dashboard-section"]} ${styles["dashboard-grid-bottom-center"]}`}
          >
            <Performances data={performancesData} />
          </div>
        </div>

        {/* Bottom Section */}
        <div className={styles["dashboard-grid"]}>
          {/* Strategies Wise Analysis */}
          <div
            className={`${styles["dashboard-section"]} ${styles["dashboard-grid-left"]}`}
          >
            <StrategiesWiseAnalysis
              data={strategiesData}
              timeFilterOptions={strategiesTimeFilterOptions}
              defaultTimeFilter="lastYear"
            />
          </div>

        </div>
      </div>

      {/* Right Side - First card: NIFTY/SENSEX, Second card: Watchlist */}
      <div className={styles["dashboard-right"]}>
        <Watchlist />
      </div>
    </div>
  );
}

export default DashboardPage;
